import React from 'react'
import useThemeClass from "utils/hooks/useThemeClass";

/**
 * Branded loader in the theme colour the user picked (indigo by default,
 * see configs/theme.config.js). Used for the initial app boot (redux-persist
 * rehydration in App.js) and as the route Suspense fallback (views/index.js),
 * so the user sees an on-brand spinner instead of a blank screen or a bare
 * grey one. Dark-mode aware.
 *
 * Props:
 *  - label:      caption under the spinner (default "Loading…")
 *  - fullScreen: min-h-screen (app boot) vs min-h-[60vh] (inside the layout)
 */
const PageLoader = ({ label = 'Loading…', fullScreen = true }) => {
	const { borderThemeFaint, borderTopTheme } = useThemeClass()
	return (
		<div
			className={`flex w-full flex-col items-center justify-center gap-5 bg-gray-50 dark:bg-gray-900 ${
				fullScreen ? 'min-h-screen' : 'min-h-[60vh]'
			}`}
		>
			<div className="relative h-16 w-16">
				{/* track */}
				<span className={`absolute inset-0 rounded-full border-4 ${borderThemeFaint} dark:border-gray-700`} />
				{/* spinning arc */}
				<span className={`absolute inset-0 animate-spin rounded-full border-4 border-transparent ${borderTopTheme}`} />
			</div>
			<div className="flex flex-col items-center gap-1">
				<span className="text-base font-semibold tracking-wide text-gray-800 dark:text-gray-100">
					Compliance&nbsp;Guru
				</span>
				<span className="text-sm text-gray-500 dark:text-gray-400">{label}</span>
			</div>
		</div>
	)
}

export default PageLoader
